<ng-container *ngIf="value; else premium">
  <div fxLayout="row" class="w-full py-1" *ngIf="tooltipDesc" [placement]="tooltipPlacement" [openDelay]="0" [ngbTooltip]="tooltipDesc" fxLayoutAlign="left center">
    <span *ngIf="showLabel" [ngClass]="class" class="badge badge-pill px-1">
      <i *ngIf="icon" [data-feather]='icon'></i> <span [ngClass]="{'center-value': icon}">{{value.toString() | titlecase}}</span>
    </span>
  </div>
  
  <div fxLayout="row" class="py-1" *ngIf="!tooltipDesc" fxLayoutAlign="left center">
    <span *ngIf="showLabel" [ngClass]="class" class="badge badge-pill px-1">
      <i *ngIf="icon" [data-feather]='icon'></i> <span [ngClass]="{'center-value': icon}">{{value.toString() | titlecase}}</span>
    </span>
  </div>
</ng-container>

<ng-template #premium>
  <div fxLayout="row" class="w-full py-1">
    <span class="badge badge-pill badge-light-secondary px-1">
      <span>Premium</span>
    </span>
  </div>
</ng-template>